import { z } from "zod";
import { cupTeamSchema } from "./util";

export const cupScoreTableSchema = z.object({
	id: z.string().nullable().optional(),
	name: z.string().nullable(),
	children: z.array(
		z.object({
			name: z.string(),
			item: z.array(
				z.object({
					name: z.string(),
					team: cupTeamSchema,
					num: z.number(),
					I: z.string(),
					B: z.string(),
					P: z.string(),
					SET: z.string(),
					O: z.string(),
				})
			),
		})
	),
});

export const cupScoreTablesSchema = z.array(cupScoreTableSchema).length(2);

export type CupScoreTableType = z.infer<typeof cupScoreTableSchema>;
